@if (subjectSessions$ | async; as subjectSessions) {
  @if (subjectSessions.length > 0) {
    <!-- Filters -->
    <form class="session-filters form-full-width animated fadeInDown" [formGroup]="filterFields">
      <mat-checkbox
        test-id="sessions-select-all-checkbox"
        [attr.data-id]="'sessions-select-all'"
        [checked]="checkedSubject.checked"
        [indeterminate]="checkedSubject.indeterminate"
        (change)="checkSubject()"
      />
      <span class="filter-field" style="flex: 3">
        <mat-form-field appearance="outline" class="solid-background">
          <mat-label>Description</mat-label>
          <mat-icon class="xs" matPrefix>filter_alt</mat-icon>
          <input
            autocomplete="off"
            formControlName="description"
            matInput
            test-id="sessions-description-filter"
            type="text"
            [attr.data-id]="'sessions-description-filter'"
          />
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <mat-form-field appearance="outline" class="solid-background">
          <mat-label>Classification</mat-label>
          <mat-icon class="xs" matPrefix>filter_alt</mat-icon>
          <input
            autocomplete="off"
            formControlName="classification"
            matInput
            test-id="sessions-classification-filter"
            type="text"
            [attr.data-id]="'sessions-classification-filter'"
          />
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <mat-form-field appearance="outline" aria-label="File Type" class="solid-background">
          <mat-select
            class="muted"
            formControlName="fileType"
            test-id="sessions-file-type-select"
            [attr.data-id]="'sessions-type-dropdown'"
          >
            <mat-option value="">All Types</mat-option>
            @for (fileType of fileTypes; track fileType) {
              <mat-option [value]="fileType">{{ fileType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </span>
    </form>
    <!-- Data -->
    @for (session of filteredSessions$ | async; track session) {
      <div class="session-card animated fadeInUp">
        <div class="session-header">{{ session.label }}</div>
        @if (session.acquisitions?.length > 0) {
          @for (acquisition of session.acquisitions; track acquisition) {
            <acquisition-files
              [acquisition]="acquisition"
              [checked]="isAcquisitionChecked(session._id, acquisition._id)"
              [session]="session"
              (checkedChange)="checkAcquisition(session._id, acquisition._id)"
            />
          }
        } @else {
          <div class="info-message">
            <div class="fab">
              <mat-icon>list</mat-icon>
            </div>
            <p>There are no acquisitions in the origin session yet.</p>
          </div>
        }
      </div>
    }
  } @else {
    <div class="blank-state">
      <mat-icon>list</mat-icon>
      <p>There are no sessions in this subject yet.</p>
    </div>
  }
} @else {
  @if (!error) {
    <div class="loading-state">
      <mat-progress-bar mode="buffer" />
    </div>
  } @else {
    <div class="info-message">
      <div class="fab">
        <mat-icon>error_outline</mat-icon>
      </div>
      <p>Sessions could not be retrieved.</p>
      <button color="primary" mat-flat-button test-id="reload-sessions-button" (click)="loadSessions()">
        Reload Sessions
      </button>
    </div>
  }
}
